import React from 'react';

import BaseForm from 'components/BaseForm/BaseForm';
import FiltersSubForms from 'components/FiltersSubForms';
import { useAdminFonctionnelFilterContext } from 'hooks/AdminFonctionnelFilterStoreContext';
import { useApi } from 'hooks/ApiStoreContext';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { DashboardAdminFonctionnelFilterFormValues } from 'pages/admin-fonctionnel/Dashboard/types';
import { CSSUtils } from 'utils/CSSUtils';

import { FormFooter } from './FormFooter';

interface DashboardAdminFonctionnelFilterFormProps {
  filter: Partial<DashboardAdminFonctionnelFilterFormValues>;
  setFilter: (
    value: Partial<DashboardAdminFonctionnelFilterFormValues>,
  ) => void;
}

function DashboardAdminFonctionnelFilterForm({
  filter,
  setFilter,
}: DashboardAdminFonctionnelFilterFormProps): React.ReactElement {
  const { ReferentielControllerApi: refController } = useApi();

  const [, , adminActionsRequises] = useAdminFonctionnelFilterContext();

  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  const initialsFilter = { ...filter };

  const subForms = FiltersSubForms(refController, adminActionsRequises);

  return (
    <BaseForm
      initialValues={initialsFilter}
      onChange={(
        changed,
        all: Partial<DashboardAdminFonctionnelFilterFormValues>,
      ) => {
        return {
          ...all,
          idModele: changed.idMarque ? undefined : all.idModele,
        };
      }}
      subForms={[
        {
          title: 'Général',
          inputs: [
            subForms.statut,
            subForms.classement,
            subForms.fourriere,
            subForms.listUniteFo,

            subForms.statutsTraitementFacturation,
            subForms.actionsRequises,

            ...(JUSTICE_ACTIVE_BOOL
              ? ([subForms.idJuridictionList] as const)
              : []),
            subForms.includeDossiersAnonymises,
            subForms.includeOnlyNotDetruitApresSorti,
          ],
        },
        {
          title: 'Mise en fourrière',
          inputs: [
            subForms.natureMiseEnFourriere,
            subForms.dateRangeMiseEnFourriere,
          ],
        },
        {
          title: 'Suivi de mise en fourrière',
          inputs: [
            subForms.dateRangeOrdreDestruction,
            subForms.dateRangeBonEnlevement,
            subForms.dateRangeSortieDefinitive,
            subForms.motifDeSortie,
          ],
        },
        {
          title: 'Véhicule',
          inputs: [subForms.marque, subForms.modele],
        },
      ]}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}

export default DashboardAdminFonctionnelFilterForm;
